"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SanctionListsOtherDescription = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.SanctionListsOtherDescription = {
    priority: 1,
    label: 'fields.payload.mor_group_answers.sanction_lists_other_description.label',
    fallbackLabel: 'Please explain which sanctions list you use for name and transaction screening (including any local autonomous lists) per region and provide an explanation as to why the aforementioned lists are not (fully) used.',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.sanction_lists', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return (!!payload.mor_group_answers?.sanction_lists && payload.mor_group_answers?.sanction_lists.filter(value => value.valueOf?.() === 'NONE').length != 0)
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return (!!payload.mor_group_answers?.sanction_lists && payload.mor_group_answers?.sanction_lists.filter(value => value.valueOf?.() === 'NONE').length != 0)
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
